/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MapInteractionsService } from '../../services/mapInteractions.service';
import { QueryService } from '../../services/query.service';
import { Select, Store } from '@ngxs/store';
import { UpdateSelectionMode } from './state/polygon-select.actions';
import { PolygonSelectModel } from './state/polygon-select.model';
import { Observable, Subject } from 'rxjs';
import { PolygonSelectState } from './state/polygon-select.state';
import { concatMap, takeUntil } from 'rxjs/operators';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
    selector: 'dash-gis-select-mode-panel',
    templateUrl: './polygon-select-mode-panel.component.html',
    styleUrls: [ './polygon-select-mode-panel.component.scss' ]
})
export class PolygonSelectModePanelComponent implements OnInit, OnDestroy {
    @Select(PolygonSelectState.getMode) public selectionMode$: Observable<PolygonSelectModel>;

    private dispose$ = new Subject<void>();

    constructor(
        private dialogRef: DialogRef<PolygonSelectModePanelComponent>,
        private queryService: QueryService,
        private mapInteractions: MapInteractionsService,
        private store: Store
    ) {}

    setSelectionMode(value) {
        const payload: PolygonSelectModel = { mode: value };
        this.store.dispatch(new UpdateSelectionMode(payload));
    }

    ngOnInit() {
        this.mapInteractions.enablePolygonSelect(this.selectFunction.bind(this));
    }

    ngOnDestroy() {
        this.mapInteractions.clearPolygonSelect();
        this.mapInteractions.enablePanInteraction();
        this.dispose$.next();
    }

    close() {
        this.dialogRef.close();
    }

    selectFunction(evt) {
        this.selectionMode$.pipe(
            concatMap(
                (selectionMode) =>
                    this.queryService.selectWithinFeature$([ evt.feature ], selectionMode)
            )
        ).subscribe(() => {
            this.dialogRef.close();
        });

    }

    get selectionModes() {
        return [
            'Intersects',
            'Within'
        ];
    }

}
